import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function BabyFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Las recetas son realmente seguras para mi bebé?',
    answer: 'Sí. Cada receta está diseñada siguiendo las recomendaciones pediátricas sobre texturas, ingredientes y progresión. Incluimos una guía completa de seguridad y prevención de atragantamientos para que te sientas tranquila.'
  }, {
    question: '¿Desde qué edad puedo usar estas recetas?',
    answer: 'Las recetas están organizadas por etapas: desde los 6 meses (primeros purés) hasta los 12+ meses (finger foods y comidas familiares). Cada receta indica claramente para qué edad es apropiada.'
  }, {
    question: '¿Necesito ingredientes especiales o caros?',
    answer: 'No. Todas las recetas usan ingredientes reales y locales que encuentras en cualquier mercado o supermercado de Latinoamérica. Sin productos gourmet ni complicaciones.'
  }, {
    question: '¿Qué pasa si mi bebé rechaza alguna comida?',
    answer: 'Es completamente normal. El ebook incluye tips sobre cómo introducir nuevos alimentos, qué hacer si tu bebé rechaza texturas, y cómo adaptar las recetas según sus preferencias. La clave es la paciencia y la consistencia.'
  }, {
    question: '¿Hay garantía?',
    answer: 'Sí, 30 días de garantía total. Si pruebas el sistema durante un mes y sientes que no te funciona, te devolvemos el 100% de tu dinero. Sin preguntas.'
  }];
  return <section className="bg-gradient-to-b from-baby-cream to-white py-12 sm:py-16 md:py-20" data-id="element-80">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-81">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12 text-gray-900 animate-fade-in-up" data-id="element-82">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-3 sm:space-y-4 stagger-children" data-id="element-83">
          {faqs.map((faq, index) => <div key={index} className="bg-white/90 backdrop-blur-baby rounded-baby-lg border-2 border-baby-pink-light/50 overflow-hidden shadow-baby-soft hover:shadow-baby-glow transition-all" data-id="element-84">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 sm:px-6 py-4 sm:py-5 flex items-center justify-between text-left hover:bg-baby-pink-light/20 transition-colors" aria-expanded={openIndex === index} data-id="element-85">
                <span className="font-semibold text-sm sm:text-base md:text-lg text-gray-900 pr-4 leading-snug" data-id="element-86">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-baby-pink transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" />
              </button>
              {openIndex === index && <div className="px-4 sm:px-6 pb-4 sm:pb-5 text-sm sm:text-base text-gray-700 leading-relaxed bg-baby-pink-light/10" data-id="element-88">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}